
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";

import "../Foundation/stylable/default-scroll-bar.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_130_0_VariableInput";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_130_0_VariableInput__root","text-small-normal":"wds_1_130_0_StylableTypography__text-small-normal","text-small-thin":"wds_1_130_0_StylableTypography__text-small-thin","text-medium-normal":"wds_1_130_0_StylableTypography__text-medium-normal","text-medium-thin":"wds_1_130_0_StylableTypography__text-medium-thin","defaultScrollBar":"wds_1_130_0_defaultscrollbar__defaultScrollBar","tagWrapper":"wds_1_130_0_VariableInput__tagWrapper","textWrapper":"wds_1_130_0_VariableInput__textWrapper","indicatorWrapper":"wds_1_130_0_VariableInput__indicatorWrapper"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-input-shadow-focus-destructive":"--wds-input-shadow-focus-destructive","wds-input-shadow-focus-standard":"--wds-input-shadow-focus-standard","wds-input-shadow-focus-warning":"--wds-input-shadow-focus-warning","rows":"--wds_1_130_0_VariableInput-rows","rowHeight":"--wds_1_130_0_VariableInput-rowHeight","contentHeight":"--wds_1_130_0_VariableInput-contentHeight"}; 




